// MobilePage.ts — the entry point for mobile.pqforce.com.
//
// ⚠ This bundle deliberately imports NEITHER jQuery NOR UIkit, unlike every
// other bundle here. Those exist for the desktop portal's pages; this app is
// served to a phone from a different host with its own stylesheet, and the
// reasoning that keeps `default.scss` off it applies to ~120 KB of framework
// just as much. See the header of `src/js/ui/mobile/dom.ts` for what is kept
// from the convention (no window globals, no inline handlers, wiring inside
// initUI*) and what is not.

import { initUIMobile } from "home/ui/mobile/ui_mobile_shell";
import { applyStoredAppearance } from "home/ui/mobile/ui_mobile_appearance";

// ⚠ FIRST, before waiting for the DOM: <html> already exists, and every frame drawn before this
// runs is drawn light. See the header of ui_mobile_appearance.ts.
applyStoredAppearance();

function start(): void {
    const root = document.getElementById("pqm-root");
    if (!root) return;
    initUIMobile(root);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
} else {
    start();
}

// The service worker is registered from the app, not the shell, so a page that
// failed to boot does not install one. Registered from the ROOT scope — see
// `pqforce-mobile-sw.php` for why it cannot live under site/assets/.
if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        const root = document.getElementById("pqm-root");
        const url = root?.dataset.swUrl;
        if (!url) return;
        // `scope: "/"` pairs with the `Service-Worker-Allowed: /` header the
        // worker is served with — see `pqforce-mobile-sw.php`. Without both, the
        // worker's scope is its own path and it controls nothing.
        navigator.serviceWorker.register(url, { scope: "/" }).catch(() => {
            // An offline shell is a bonus, not the product. A failure here must
            // never stop the app.
        });
    });
}
